import { AsyncPipe, TitleCasePipe, LowerCasePipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom, ApplicationConfig } from '@angular/core';
import {
	ErrorStateMatcher,
	ShowOnDirtyErrorStateMatcher
} from '@angular/material/core';
import { BrowserModule, ɵDomSanitizerImpl } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { provideStore } from '@ngxs/store';
import { AuthInterceptorFn } from '@core';
import { COMMON_MODULE_IMPORT } from '@shared/modules/common-module';
import { MATERIAL_MODULE_IMPORTS } from '@shared/modules/mat-module';
import { RootStates } from '@shared/stores';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ToastrModule } from 'ngx-toastr';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MessagingService } from '@shared/services/messaging.service';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import {
	PhoneFormatPipe,
	StringTransformPipe,
	NameInitialsPipe,
	AddressPipe,
	AssetsImgUrlPipe,
	BaseTotalAmountPipe,
	CopiedVariationsPipe,
	CustomDatePipe,
	GetPaymentInfo,
	GetPrimaryImage,
	GetStatusClass,
	GetTransactionMethod,
	GetTransactionStatus,
	GetTransactionType,
	MergePrimeAttrPipe,
	ObjectPipe,
	OxCurrencyPipe,
	PermissionPipe,
	SizeTextLimitPipe,
	StringCapitalizePipe
} from '@shared/pipes';
import { LightboxModule } from 'ngx-lightbox';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { environment } from '@environment/environment';
import { StorageService } from '@shared/services';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';

const pipes = [
	PhoneFormatPipe,
	StringTransformPipe,
	NameInitialsPipe,
	AddressPipe,
	AssetsImgUrlPipe,
	BaseTotalAmountPipe,
	CopiedVariationsPipe,
	AsyncPipe,
	TitleCasePipe,
	LowerCasePipe,
	CurrencyPipe,
	CustomDatePipe,
	GetPaymentInfo,
	GetPrimaryImage,
	GetStatusClass,
	GetTransactionMethod,
	GetTransactionStatus,
	GetTransactionType,
	MergePrimeAttrPipe,
	ObjectPipe,
	OxCurrencyPipe,
	PermissionPipe,
	SizeTextLimitPipe,
	StringCapitalizePipe,
	DecimalPipe
]

const services = [
	NgxImageCompressService,
	MessagingService,
	StorageService
]

export const appConfig: ApplicationConfig = {
	providers: [
		importProvidersFrom(
			BrowserModule,
			COMMON_MODULE_IMPORT,
			MATERIAL_MODULE_IMPORTS,
			ToastrModule.forRoot(),
			LightboxModule
		),
		provideRouter(appRoutes, withComponentInputBinding()),
		...pipes,
		...services,
		ɵDomSanitizerImpl,
		{ provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
		provideHttpClient(withInterceptors([AuthInterceptorFn])),
		provideAnimations(),
		provideStore(RootStates, {
			developmentMode: !environment.production
		}, withNgxsReduxDevtoolsPlugin({
			name: 'OrderAxe Web App',
			maxAge: 50
		})),
		provideEnvironmentNgxMask(),
		provideNgxSkeletonLoader(),
		{
			provide: MAT_BOTTOM_SHEET_DATA,
			useValue: {}
		},
		{
			provide: MAT_DIALOG_DATA,
			useValue: {}
		},
		{
			provide: MatBottomSheetRef,
			useValue: {}
		},
		{
			provide: MatDialogRef,
			useValue: {}
		},
		provideFirebaseApp(() => initializeApp(environment.firebase)),
		provideMessaging(() => getMessaging()),
		{
			provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
			useValue: {
			  position: 'above'
			}
		}
	]
}
